<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: Johnny Palmer
  Author URL: http://sweetas.xyz
========================================================================================== -->


<template>
<div class="relative">
  <div class=" vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">
      <vs-button type="flat"  :to="{path: '/search'}"> 
      <feather-icon icon="HomeIcon" class="cursor-pointer ml-4 mr-6 mt-1" />
      </vs-button>
      <div class="vx-logo cursor-pointer mx-auto flex items-center">
        <span class="vx-logo-text text-primary">Infopoint - {{location}}</span>
      </div>

      <cart-drop-down />

      <profile-drop-down />

    </vs-navbar>
  </div>
</div>
</template>

<script>
import CartDropDown         from './components/CartDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    CartDropDown,
    ProfileDropDown
  },
  computed: {
    location () {        
      let p = this.$route.path
      let t =  this.$store.state.eCommerce.ipid
      if(p.includes("/pubs")){
        // this is default
      }
      if(p.includes("/admin")){
        if(p.replace("/admin","") == ""){
         t = "Admin"
        }
        if(p.replace("/admin","") != ""){
         t = p.replace("/admin/","")
        }
      }   
      if(p.includes("/search")){
        t = "Search"       
      }   
      
      var r = this.$store.state.AppActiveUser
      if(r.overRideCompany ===1) {
        t = "Volunteer" 
      }



      return t.toUpperCase()
    },
    navbarColor () {
      let color = '#fff'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#10163a'
        } else {
          color = '#262c49'
        }
      }

      return color
    },
    isThemedark ()          { return this.$store.state.theme                                                                       },
    navbarStyle ()          { return this.navbarType === 'static' ? {transition: 'all .25s ease-in-out'} : {}                      },
    navbarClasses ()        { return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none' },
    scrollY ()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth ()          { return this.$store.state.windowWidth                                                                 }
  }
}

</script>
<style lang="css" scoped>
.large-2x > i {font-size:3rem!important;}
</style>

